import { useMutation, useQueryClient } from '@tanstack/react-query';

import type { CreateMessageTemplatePayload } from 'api/MessageTemplatesApi';
import { MessageTemplatesApi } from 'api/MessageTemplatesApi';
import { MESSAGE_TEMPLATES_KEY } from 'tanstack-hooks/keys';
import { useUser } from 'tanstack-hooks/user';

export function useCreateMessageTemplate() {
  const messageTemplatesApi = new MessageTemplatesApi();
  const { userBankId } = useUser();
  const queryClient = useQueryClient();

  const { mutateAsync: createMessageTemplate, isPending: isCreatingMessageTemplate } = useMutation({
    mutationKey: [MESSAGE_TEMPLATES_KEY, 'create'],
    mutationFn: (data: CreateMessageTemplatePayload) =>
      messageTemplatesApi.createMessageTemplate(userBankId, data),
    onSuccess: () => {
      // Invalidate every cached message-templates list for this bank (all version/last_updated_only
      // param variants) so the new draft is refetched — a prefix match on the query key, since
      // callers vary the params (e.g. the Library requests draft,latest).
      queryClient.invalidateQueries({ queryKey: [MESSAGE_TEMPLATES_KEY, userBankId] });
    },
    meta: {
      snackbarErrorMessage: 'There was an issue creating the template. Please contact support.'
    }
  });

  return { createMessageTemplate, isCreatingMessageTemplate };
}
